// get_product_subcategories
export const GET_PRODUCT_SUBCATEGORIES = 'get_product_subcategories';
export const GET_PRODUCT_SUBCATEGORIES_SUCCESSFUL =
  'get_product_subcategories_successfull';
export const GET_PRODUCT_SUBCATEGORIES_FAILED =
  'get_product_subcategories_failed';

// create_product_subcategory
export const CREATE_PRODUCT_SUBCATEGORY = 'create_product_subcategory';
export const CREATE_PRODUCT_SUBCATEGORY_SUCCESSFUL =
  'create_product_subcategory_successfull';
export const CREATE_PRODUCT_SUBCATEGORY_FAILED =
  'create_product_subcategory_failed';

// update_product_subcategory
export const UPDATE_PRODUCT_SUBCATEGORY = 'update_product_subcategory';
export const UPDATE_PRODUCT_SUBCATEGORY_SUCCESSFUL =
  'update_product_subcategory_successfull';
export const UPDATE_PRODUCT_SUBCATEGORY_FAILED =
  'update_product_subcategory_failed';

// delete_product_subcategory
export const DELETE_PRODUCT_SUBCATEGORY = 'delete_product_subcategory';
export const DELETE_PRODUCT_SUBCATEGORY_SUCCESSFUL =
  'delete_product_subcategory_successfull';
export const DELETE_PRODUCT_SUBCATEGORY_FAILED =
  'delete_product_subcategory_failed';

// exchange_product_subcateory_order
export const EXCHANGE_PRODUCT_SUBCATEORY_ORDER =
  'exchange_product_subcateory_order';
export const EXCHANGE_PRODUCT_SUBCATEORY_ORDER_SUCCESSFUL =
  'exchange_product_subcateory_order_successfull';
export const EXCHANGE_PRODUCT_SUBCATEORY_ORDER_FAILED =
  'exchange_product_subcateory_order_failed';
